import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';
import { ClinicPatient, DataSourceResponse, SignalInformation } from '../../models';


@Injectable({ providedIn: 'root' })
export class ClinicPatientService extends ApiService {
  endPoint = '/api/clinicPatients';
  create(model: ClinicPatient) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: ClinicPatient) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<ClinicPatient> {
    return this.http.get<ClinicPatient>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  getByCaseHistory(id: string): Observable<ClinicPatient> {
    return this.http.get<ClinicPatient>(`${this.clinicsBaseURL}${this.endPoint}/by-case-history/${id}`);
  }
  getByRegisterPatient(id: string): Observable<ClinicPatient> {
    return this.http.get<ClinicPatient>(`${this.clinicsBaseURL}${this.endPoint}/by-register-patient/${id}`);
  }
  getList(queryParams: any): Observable<DataSourceResponse<ClinicPatient>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
  changeImage(id: string, imagePath: string) {
    return this.http.put<any>(`${this.clinicsBaseURL}${this.endPoint}/changeImage/${id}`, { "base64String": imagePath });
  }
  updateSignalInformation(id: string, model: any) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}/signalInformation`, model);
  }
}
